import React, { useState } from "react";
import "../Styles/UseCase.scss";
import EngageAIContent from "./Products/EngageAI/EngageAIContent";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles, Check, ArrowRight, LayoutGrid } from "lucide-react";

// Framer Motion Stagger Variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.05,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 28, scale: 0.96 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: [0.16, 1, 0.3, 1],
    },
  },
};

export default function Usecase({ content }) {
  const [showAllUseCases, setShowAllUseCases] = useState(false);

  const useCases =
    Array.isArray(content) && content.length
      ? content
      : EngageAIContent.usecase || [];

  const visibleUseCases = showAllUseCases ? useCases : useCases.slice(0, 3);
  const hasMoreUseCases = useCases.length > 3;

  return (
    <div className="usecase-wrapper">
      <section className="usecase-section">
        {/* Apple Editorial Header Meta */}
        <div className="usecase-header-meta">
          <span className="usecase-label-apple">USE CASES</span>
          <h2 className="usecase-main-title">Engineered for Enterprise Impact</h2>
          <p className="usecase-main-sub">
            Discover how our specialized AI agents solve complex operational challenges across industries.
          </p>
        </div>

        {/* Apple Spatial Ceramic Industry Cards Grid with Staggered Entrance */}
        <div className="usecase-container">
          <motion.div
            className="usecase-grid"
            key={showAllUseCases ? "all" : "limited"}
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            <AnimatePresence mode="popLayout">
              {visibleUseCases.map((useCase, index) => (
                <motion.div
                  className="usecase-card"
                  key={useCase.industry + index}
                  variants={cardVariants}
                  layout
                >
                  {/* Industry Header Row */}
                  <div className="usecase-card-header">
                    <div className="usecase-icon-stage">
                      <Sparkles size={18} />
                    </div>
                    <h3 className="usecase-industry-title">{useCase.industry}</h3>
                  </div>

                  {/* Points Checklist */}
                  <ul className="usecase-features-list">
                    {useCase.points?.map((point, idx) => (
                      <li key={idx} className="usecase-feature-item">
                        <div className="usecase-check-icon">
                          <Check size={14} />
                        </div>
                        <span className="usecase-point-text">{point}</span>
                      </li>
                    ))}
                  </ul>

                  {/* Apple Link CTA Footer */}
                  <div className="usecase-card-footer">
                    <div className="usecase-link-btn">
                      <span>Explore Solution</span>
                      <ArrowRight size={15} className="usecase-btn-arrow" />
                    </div>
                  </div>
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>

          {/* Bottom Center Action Button */}
          {hasMoreUseCases && (
            <div className="usecase-bottom-action">
              <button
                type="button"
                className="view-all-usecases-btn"
                onClick={() => setShowAllUseCases(!showAllUseCases)}
              >
                <LayoutGrid size={16} />
                <span>
                  {showAllUseCases
                    ? "Show less"
                    : `View all use cases (${useCases.length})`}
                </span>
                <ArrowRight
                  size={14}
                  style={{
                    transform: showAllUseCases
                      ? "rotate(-90deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                />
              </button>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
